import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useUserPositionOptions.ts
var testData = {
	total: 3,
	userPositionOptions: [
		{
			color: "rgb(125,156,187)",
			id: "ID_01",
			organizationId: "AB1",
			regionIds: [],
			title: "Patrol Officer"
		},
		{
			color: "#d66b1f",
			id: "ID_02",
			organizationId: "AB1",
			regionIds: [],
			title: "Supervisor"
		},
		{
			color: "#8bdc4a",
			id: "ID_03",
			organizationId: "AB1",
			regionIds: [],
			title: "Watch Commander"
		}
	]
};
function useUserPositionOptions(args, opts = {}) {
	const { data, isCalling } = useRPC(RPCs.Users.GetUserPositionOptionsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling
	};
}
//#endregion
export { useUserPositionOptions };

//# sourceMappingURL=useUserPositionOptions.js.map